import styled from "styled-components";

export const Container = styled.article`
  position: relative;
  display: flex;
  width: 290px;
  padding: 0.5rem;
  height: 60px;
  align-items: flex-end;
  background-color: var(--secondary-color);
  color: var(--primary-color);
  border-radius: 5px;
  border-bottom-right-radius: 50px;
  margin: 0.5rem 0;
`;
export const IntraContainer = styled.article`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  button {
    position: absolute;
    top: 0.5rem;
    right: 1rem;
  }
`;
export const Infos = styled.div`
  max-width: 80%;
  height: 100%;
  line-break: normal;
`;
export const Quantity = styled.p`
  color: var(--secondary-color);
  position: absolute;
  bottom: -5px;
  right: 0;
`;
